export default {
  'token-info.page-title': 'Token Info',
};
